import React, { FC } from 'react';

import { PasswordUpdateFormData } from 'types';
import { useAppDispatch } from 'store';
import { resetPasswordAction, setAuthInfo } from 'store/auth/auth.reducer';
import { PasswordUpdateForm } from './components/PasswordUpdateForm/PasswordUpdateForm';

interface Props {
  onFinish?: () => void;
  accessToken: string;
  appearance?: 'default' | 'login';
}

export const PasswordUpdate: FC<Props> = ({ onFinish, accessToken, appearance }) => {
  const dispatch = useAppDispatch();

  const handlePasswordUpdate = async ({ password }: PasswordUpdateFormData) => {
    await dispatch(resetPasswordAction({ password, accessToken }));
    await dispatch(setAuthInfo({ data: { token: accessToken }}));
    onFinish && onFinish();
  };
  return (
    <PasswordUpdateForm onSubmit={handlePasswordUpdate} appearance={appearance} />
  );
};
